import React from "react";
import { ActiveFormats, FormatCommand } from "./types";
import {
  BoldIcon,
  BulletListIcon,
  ItalicIcon,
  NumberedListIcon,
} from "../InlineIcons";

interface ToolbarProps {
  activeFormats: ActiveFormats;
  onFormat: (command: FormatCommand) => void;
}

const btnClass = (isActive: boolean) =>
  `community-composer__fmtbtn ${isActive ? "community-composer__fmtbtn--active" : ""}`;

// A `mousedown` (not `click`) with `preventDefault` runs the command before
// the browser can shift focus/selection away from the editable region onto
// the button itself — losing the selection is the classic contenteditable
// toolbar bug.
const handleMouseDown = (
  event: React.MouseEvent<HTMLButtonElement>,
  onFormat: (command: FormatCommand) => void,
  command: FormatCommand,
) => {
  event.preventDefault();
  onFormat(command);
};

const Toolbar = ({ activeFormats, onFormat }: ToolbarProps) => (
  <div
    className="community-composer__fmt"
    role="group"
    aria-label="Text formatting"
  >
    <button
      className={btnClass(activeFormats.isBold)}
      type="button"
      aria-label="Bold"
      title="Bold"
      aria-pressed={activeFormats.isBold}
      onMouseDown={(event) => handleMouseDown(event, onFormat, "bold")}
    >
      <BoldIcon />
    </button>
    <button
      className={btnClass(activeFormats.isItalic)}
      type="button"
      aria-label="Italic"
      title="Italic"
      aria-pressed={activeFormats.isItalic}
      onMouseDown={(event) => handleMouseDown(event, onFormat, "italic")}
    >
      <ItalicIcon />
    </button>
    <button
      className={btnClass(activeFormats.isBulleted)}
      type="button"
      aria-label="Bulleted list"
      title="Bulleted list"
      aria-pressed={activeFormats.isBulleted}
      onMouseDown={(event) => handleMouseDown(event, onFormat, "insertUnorderedList")}
    >
      <BulletListIcon />
    </button>
    <button
      className={btnClass(activeFormats.isNumbered)}
      type="button"
      aria-label="Numbered list"
      title="Numbered list"
      aria-pressed={activeFormats.isNumbered}
      onMouseDown={(event) => handleMouseDown(event, onFormat, "insertOrderedList")}
    >
      <NumberedListIcon />
    </button>
  </div>
);

export default Toolbar;
